import React from "react";

import Timeline from "src/components/Timeline/Timeline.tsx";
import { TimelineEventDetails } from "src/components/Timeline/TimelineEvent.tsx";
import { useT } from "src/internationalization";
import { Alert } from "src/types/alert.ts";

type AlertTimelineProps = {
  alert?: Alert | null;
};

export const AlertTimeline: React.FC<AlertTimelineProps> = ({ alert }) => {
  const t = useT();

  const getAlertTimelineEvents = (alert?: Alert | null): TimelineEventDetails[] => {
    if (!alert) {
      return [];
    }

    const timelineEvents: TimelineEventDetails[] = [];

    timelineEvents.push({
      title: t("page.alert.tab.synthesis.widget.chronology.date.requested"),
      date: alert.requestedDate,
      type: "info",
    });

    timelineEvents.push({
      title: t("page.alert.tab.synthesis.widget.chronology.date.imported"),
      date: alert.caseImportedDate,
      type: "info",
    });

    timelineEvents.push({
      title: t("page.alert.tab.synthesis.widget.chronology.date.caseScored"),
      date: alert.caseScoringDate,
      type: "info",
    });

    timelineEvents.push({
      title: t("page.alert.tab.synthesis.widget.chronology.date.generated"),
      date: alert.creationDate,
      type: "warning",
    });

    if (alert.isAlertValidated) {
      timelineEvents.push({
        title: t("page.alert.tab.synthesis.widget.chronology.date.validated"),
        date: alert.validationDate,
        type: "success",
      });
    }

    return timelineEvents;
  };

  return <Timeline events={getAlertTimelineEvents(alert)} />;
};
